import React from 'react';
import { Piece as PieceComponent } from './Piece';
import type { Position, Piece } from '@/types';
import styles from './Square.module.css';

interface SquareProps {
  position: Position;
  piece: Piece | undefined;
  isLight: boolean;
  isSelected: boolean;
  isLegalMove: boolean;
  isHighlighted: boolean;
  isLastMove: boolean;
  isCheck: boolean;
  onClick: (position: Position) => void;
}

export const Square: React.FC<SquareProps> = ({
  position,
  piece,
  isLight,
  isSelected,
  isLegalMove,
  isHighlighted,
  isLastMove,
  isCheck,
  onClick,
}) => {
  const squareClasses = [
    styles.square,
    isLight ? styles.light : styles.dark,
    isSelected && styles.selected,
    isLegalMove && styles.legalMove,
    isHighlighted && styles.highlighted,
    isLastMove && styles.lastMove,
    isCheck && styles.check,
  ].filter(Boolean).join(' ');
  
  return (
    <div 
      className={squareClasses}
      onClick={() => onClick(position)}
      data-file={position.file}
      data-rank={position.rank}
    >
      {piece && <PieceComponent piece={piece} />}
      {isLegalMove && !piece && (
        <div className={styles.legalMoveDot} />
      )}
    </div>
  );
};